import React from "react";
import { GroupTypingIndicatorProps } from "../types";

const GroupTypingIndicator: React.FC<GroupTypingIndicatorProps> = ({
  typingUsers,
}) => {
  if (!typingUsers || typingUsers.length === 0) return null;

  return (
    <div className="px-4 py-2 flex items-center gap-2 text-sm text-indigo-600 dark:text-indigo-400 animate-pulse">
      {typingUsers.map((user, idx) => (
        <span key={user.id} className="flex items-center gap-1">
          <img
            src={user.photo}
            alt={user.name}
            className="w-6 h-6 rounded-full border border-indigo-200 mr-1"
          />
          <span>
            {user.name}
            {idx < typingUsers.length - 1 ? "," : ""}
          </span>
        </span>
      ))}
      <span>
        {typingUsers.length === 1
          ? "is typing..."
          : typingUsers.length === 2
          ? "are typing..."
          : "and others are typing..."}
      </span>
    </div>
  );
};

export default GroupTypingIndicator;
